import axios from "axios"
import type { AxiosRequestHeaders } from "axios"
import { useGlobalState } from "../contexts/GlobalState"
import { useEffect, useState } from "react"

const useAxiosInterceptor = () => {
    const { state: { accessToken = "" } = {}, setReady } = useGlobalState()
    const [ready, setIsReady] = useState(false)

    useEffect(() => {
        const interceptorId = axios.interceptors.request.use((config) => {
            return {
                ...config,
                paramsSerializer: {
                    indexes: null,
                },
                headers: accessToken
                    ? ({
                          ...config.headers,
                          Accept: "application/json",
                          // "Content-Type": "application/json; charset=utf-8",
                          Authorization: "Bearer " + accessToken,
                      } as AxiosRequestHeaders)
                    : config.headers,
                synchronous: true,
            }
        })
        const isReady = Boolean(accessToken)
        setIsReady(isReady)
        setReady(isReady)

        return () => {
            axios.interceptors.request.eject(interceptorId)
        }
    }, [accessToken, setReady])

    return ready
}

export default useAxiosInterceptor
